import script from "./DisplayPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayPrice.vue?vue&type=script&setup=true&lang=js"

import "./DisplayPrice.vue?vue&type=style&index=0&id=ada4f812&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada4f812"]])

export default __exports__